// グローバルスコープで初期化関数を定義
window.initStoreSelector = function() {
  console.log('initStoreSelector called'); // デバッグ用
  const searchInput = document.getElementById('store-search');
  if (!searchInput) {
    console.log('Search input not found'); // デバッグ用
    return;
  }

  try {
    const autocomplete = new google.maps.places.Autocomplete(searchInput, {
      types: ['establishment'],
      componentRestrictions: { country: 'jp' }
    });

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      const searchResults = document.getElementById('selected-store-display');
      
      if (!place.geometry) {
        searchResults.innerHTML = '<p class="error">選択された店舗が見つかりません</p>';
        return;
      }

      // 店舗情報の表示を更新
      updateStoreDisplay(place, searchResults);

      // 隠しフィールドに値を設定
      document.getElementById('store-name').value = place.name;
      document.getElementById('store-address').value = place.formatted_address;
    });
  } catch (error) {
    console.error('Google Maps initialization error:', error);
  }
};

// 店舗表示を更新する関数
function updateStoreDisplay(place, searchResults) {
  let photoHtml = '';
  if (place.photos && place.photos.length > 0) {
    try {
      photoHtml = `
        <div class="store-photo">
          <img src="${place.photos[0].getUrl({maxWidth: 300, maxHeight: 200})}" alt="${place.name}">
        </div>
      `;
    } catch (error) {
      console.error('Error loading store photo:', error);
    }
  }

  const mapHtml = `
    <div id="store-map" style="height: 200px; margin-top: 10px;"></div>
  `;

  searchResults.innerHTML = `
    <div class="selected-store">
      <h3 class="store-name">${place.name}</h3>
      <p class="store-address">${place.formatted_address}</p>
      ${photoHtml}
      ${mapHtml}
    </div>
  `;

  // 地図の表示
  try {
    const map = new google.maps.Map(document.getElementById('store-map'), {
      center: place.geometry.location,
      zoom: 15
    });

    new google.maps.Marker({
      map: map,
      position: place.geometry.location
    });
  } catch (error) {
    console.error('Error initializing map:', error);
  }
}

// エラーハンドリング
window.gm_authFailure = function() {
  console.error('Google Maps API authentication failed');
  const searchContainer = document.getElementById('store-search-container');
  if (searchContainer) {
    searchContainer.innerHTML = '<p class="error">Google Maps APIの読み込みに失敗しました。</p>';
  }
};

// 予約フォームの初期化関数
function initReservationForm() {
  const dateInputs = document.querySelectorAll('.date-picker');
  
  if (dateInputs.length > 0) {
    // 日本語ロケールを設定
    flatpickr.localize(flatpickr.l10ns.ja);
    
    dateInputs.forEach(input => {
      // 既存のflatpickrインスタンスを破棄
      if (input._flatpickr) {
        input._flatpickr.destroy();
      }

      flatpickr(input, {
        dateFormat: 'Y/m/d',
        minDate: 'today',
        maxDate: new Date().fp_incr(90),
        disableMobile: false,
        locale: 'ja',
        onChange: function(selectedDates, dateStr, instance) {
          validateDateSelection(input.id, dateStr);
        }
      });
    });
  }

  // 人数選択の初期化
  initPeopleCounter();
}

// 日付選択のバリデーション
function validateDateSelection(inputId, selectedDate) {
  const dateInputs = document.querySelectorAll('.date-picker');
  const selectedDates = new Set();
  let hasDuplicate = false;

  dateInputs.forEach(input => {
    if (input.value && input.id !== inputId) {
      if (selectedDates.has(input.value)) {
        hasDuplicate = true;
      }
      selectedDates.add(input.value);
    }
  });

  if (hasDuplicate) {
    alert('同じ日付は選択できません。別の日付を選択してください。');
    document.getElementById(inputId).value = '';
  }
}

// 人数カウンターの初期化
function initPeopleCounter() {
  const adults = document.getElementById('adults');
  const children = document.getElementById('children');
  const totalCount = document.getElementById('total-count');

  if (adults && children && totalCount) {
    function updateTotal() {
      const adultsValue = parseInt(adults.value) || 0;
      const childrenValue = parseInt(children.value) || 0;
      totalCount.textContent = adultsValue + childrenValue;
    }

    adults.addEventListener('change', updateTotal);
    children.addEventListener('change', updateTotal);

    // 初期値の設定
    updateTotal();
  }
}

// 既存のイベントリスナーを修正
document.addEventListener('DOMContentLoaded', function() {
  if (typeof StoreSelector !== 'undefined') {
    StoreSelector.init();
  }
  initReservationForm();
});

document.addEventListener('shopify:section:load', function() {
  if (typeof StoreSelector !== 'undefined') {
    StoreSelector.init();
  }
  initReservationForm();
});